import { useState } from "react";
import { useCart } from "../context/CartContext";
import styles from "./Deals.module.css";
import rings from "../data/rings";
import pendants from "../data/pendants";

const allProducts = [
  ...rings.map(r => ({ ...r, category: "ring" })),
  ...pendants.map(p => ({ ...p, category: "pendant" })),
].filter(p => p.deal === true && p.originalPrice);

function DealCard({ item, index }) {
  const { addToCart, items } = useCart();
  const [added, setAdded] = useState(false);
  const inCart = items.some(i => i.id === item.id);
  const discount = Math.round((1 - item.price / item.originalPrice) * 100);
  const installment = Math.ceil(item.price / 3).toLocaleString();

  const handleAddToCart = () => {
    addToCart(item);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  const handleInquire = () => {
    const msg = encodeURIComponent(`Hello! I'm interested in the ${item.name} deal. Could you provide more details?`);
    window.open(`https://wa.me/94765851400?text=${msg}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.card}>
      {/* Discount badge */}
      <div className={styles.discountBadge}>{discount}% OFF</div>

      {/* Image */}
      <div className={styles.imageWrap} onClick={() => window.location.href = `/product/${item.id}`}>
        <img src={item.src} alt={item.name} className={styles.image} />
        <div className={styles.overlay} />
        <span className={styles.gemBadge}>{item.gem}</span>
      </div>

      {/* Info */}
      <div className={styles.info}>
        <h3 className={styles.name} onClick={() => window.location.href = `/product/${item.id}`}>{item.name}</h3>
        <p className={styles.description}>{item.description}</p>

        <div className={styles.priceRow}>
          <span className={styles.originalPrice}>LKR {item.originalPrice.toLocaleString()}</span>
          <span className={styles.price}>LKR {item.price.toLocaleString()}</span>
        </div>

        <div className={styles.mintpayLine}>
          <span className={styles.mintpayText}>or 3 × LKR {installment} with</span>
          <img src="/mintpay-logo.webp" alt="Mintpay" className={styles.mintpayLogo} />
        </div>

        <div className={styles.btnRow}>
          <button className={styles.inquireBtn} onClick={handleInquire}>
            <img src="/whatsapp-logo.png" alt="WhatsApp" width={14} height={14} />
            Inquire
          </button>
          <button
            className={`${styles.cartBtn} ${inCart ? styles.cartBtnAdded : ""}`}
            onClick={handleAddToCart}
            disabled={inCart}
          >
            {inCart ? "In Cart ✓" : added ? "Added!" : "Add to Cart"}
          </button>
        </div>
        <button className={styles.viewBtn} onClick={() => window.location.href = `/product/${item.id}`}>
          View Details
        </button>
      </div>
    </div>
  );
}

export default function Deals() {
  if (allProducts.length === 0) return null;

  return (
    <section id="deals" className={styles.section}>
      <div className={styles.header}>
        <p className={styles.eyebrow}>Limited Time</p>
        <h2 className={styles.title}>Special Deals</h2>
        <div className={styles.divider} />
      </div>
      <div className={styles.grid}>
        {allProducts.map((item, i) => (
          <DealCard key={item.id} item={item} index={i} />
        ))}
      </div>
    </section>
  );
}